import type { CancelablePromise } from "@zenith/services/user/core/CancelablePromise";
import { OpenAPI } from "@zenith/services/user/core/OpenAPI";
import { request as __request } from "@zenith/services/user/core/request";
import type { ApiResponseDTOVoid } from "@zenith/services/user/models/ApiResponseDTOVoid";
import type { TeamPasscodeResetRequest } from "@zenith/services/user/models/TeamPasscodeResetRequest";

// PUT /api/corporate/team/passcode/reset (resetPasscode1 in the latest spec).
// Kept here instead of in the generated client, which isn't regenerated yet
export const resetTeamPasscode = (
  requestBody: TeamPasscodeResetRequest,
  xMfa?: string
): CancelablePromise<ApiResponseDTOVoid> =>
  __request(OpenAPI, {
    method: "PUT",
    url: "/api/corporate/team/passcode/reset",
    headers: {
      "X-MFA": xMfa,
    },
    body: requestBody,
    mediaType: "application/json",
    errors: {
      400: `Bad Request`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
      500: `Internal Server Error`,
      501: `Not Implemented`,
    },
  });
